<script setup lang="ts">
import { computed } from "vue";
import { useColorMode } from "@vueuse/core";
import { useI18n } from "vue-i18n";
import { Moon, Sun } from "@lucide/vue";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

const { t } = useI18n();

// Persists to localStorage and toggles the `.dark` class on <html>.
const mode = useColorMode({ initialValue: "dark" });
const isDark = computed(() => mode.value === "dark");
const toggleLabel = computed(() => (isDark.value ? t("theme.toLight") : t("theme.toDark")));

function toggle() {
  mode.value = isDark.value ? "light" : "dark";
}
</script>

<template>
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger as-child>
        <Button variant="ghost" size="icon" :aria-label="toggleLabel" @click="toggle">
          <Sun v-if="isDark" class="size-4" />
          <Moon v-else class="size-4" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>{{ toggleLabel }}</TooltipContent>
    </Tooltip>
  </TooltipProvider>
</template>
